/**
 * Plugin global BMT — Sprint #46 (20/06/2026).
 *
 * Espelha o bmtInboxHealthPlugin (UICS / REFACTOR-COMPOSABLES): inicia/para o
 * polling 5s das BmtBotSessions :active enquanto o usuario esta dentro de
 * /app/accounts/:accountId (excluindo account_suspended).
 *
 * As actions startPolling/stopPolling do store sao idempotentes, entao chamadas
 * repetidas via afterEach nao vazam timers.
 *
 * Registrar UMA VEZ em entrypoints/dashboard.js, junto com o
 * bmtInboxHealthPlugin, passando { store, router }.
 */
const isInsideAccountApp = route => {
  if (!route || !Array.isArray(route.matched)) return false;
  return route.matched.some(
    record =>
      typeof record.path === 'string' &&
      record.path.startsWith('/app/accounts/') &&
      record.name !== 'account_suspended'
  );
};

export default {
  install(app, options = {}) {
    const { store, router } = options;
    if (!store || !router) {
      // eslint-disable-next-line no-console
      console.warn('[bmtBotActivityPlugin] requer { store, router }');
      return;
    }

    const sync = route => {
      if (isInsideAccountApp(route)) {
        store.dispatch('bmtBotActivity/startPolling');
      } else {
        store.dispatch('bmtBotActivity/stopPolling');
      }
    };

    router.afterEach(to => sync(to));

    if (router.currentRoute && router.currentRoute.value) {
      sync(router.currentRoute.value);
    }
  },
};
